<template>
  <div class="text-secondary">
    {{ $t('userProfile.mfaEnabled.accountSecurity') }}
  </div>
  <div class="d-flex align-center my-2">
    <BMCheckBox
      class="mr-4 mr-sm-0"
      disabled
      data-cc="user-mfa-status-checkbox"
      :label="$t('userProfile.mfaEnabled.mfaEnabledTitle')"
      :model-value="true"
    />
  </div>
  <div class="text-gray">
    {{ $t('userProfile.mfaEnabled.mfaEnabledDescription') }}
  </div>
</template>

<script setup>
import BMCheckBox from '@/components/common/BMCheckBox/BMCheckBox.vue';
</script>
